import {DeltaEvent, DeltaEventMethodType, UpdateType} from "../../../gd/manager/delta-handler/types";
import createUpdateAction from "../../../gd/manager/delta-handler/session-events-handlers/task/create-update-action";

// const debug = "convertMeetingEventToUpdateAction"
const debug = false

export function convertMeetingEventToUpdateAction(deltaEvent:DeltaEvent) {

    debug && console.log(debug, 'process', deltaEvent)

    switch (deltaEvent.method) {
        case DeltaEventMethodType.NEW   :
            return createUpdateAction(UpdateType.MEETING_NEW, deltaEvent.data)

        case DeltaEventMethodType.DELETE:
            return createUpdateAction(UpdateType.MEETING_DELETE, {id: deltaEvent.header.meeting.id})

        case DeltaEventMethodType.DELTA :
            const deltaData = _.assign({}, deltaEvent.data, {id: deltaEvent.header.meeting.id})
            return createUpdateAction(UpdateType.MEETING_DELTA, deltaData)
    }
}